import { Order } from '@/types/booking'
import { Seat } from '@/types'
import { Basket } from '../types'
import { create } from 'zustand'

export enum BasketType {
  UPGRADE = 'upgrade',
  SWAP = 'swap',
  REFUND = 'refund',
}

type BasketState = {
  basketType?: BasketType
  basket: Basket | undefined

  // swap dates
  newEventDate?: string
  newEventTime?: string
  newOrder?: Order

  // seat checkout (formerly useCartStore)
  seatsPendingPayment: Seat[]
  loadingPayment: boolean
  totalSaved?: number

  setBasket: (basket?: Basket) => void
  removeBasket: () => void
  setBasketType: (basketType: BasketType) => void
  setNewEventDate: (newEventDate: string) => void
  setNewEventTime: (newEventTime: string) => void
  setNewOrder: (order: Order) => void
  setSeatsPendingPayment: (value: Seat[]) => void
  setLoadingPayment: (value: boolean) => void
  setTotalSaved: (value?: number) => void
}

export const useBasketStore = create<BasketState>((set) => ({
  basketType: undefined,
  basket: undefined,
  newEventDate: undefined,
  newEventTime: undefined,
  newOrder: undefined,
  seatsPendingPayment: [],
  loadingPayment: false,
  totalSaved: undefined,
  setBasket: (basket?: Basket) => set({ basket }),
  removeBasket: () => set({ basket: undefined }),
  setBasketType: (basketType: BasketType) => set({ basketType }),
  setNewEventDate: (newEventDate: string) => set({ newEventDate }),
  setNewEventTime: (newEventTime: string) => set({ newEventTime }),
  setNewOrder: (newOrder: Order) => set({ newOrder }),
  setSeatsPendingPayment: (value) => set({ seatsPendingPayment: value }),
  setLoadingPayment: (value) => set({ loadingPayment: value }),
  setTotalSaved: (value) => set({ totalSaved: value }),
}))
